import find from 'lodash/find';
import createCachedSelector from 're-reselect';

const byType = state => state.entities.costEstimate.byType;
/* eslint-disable no-sequences */
export const getCostEstimateForType = createCachedSelector(
    byType, (state, typeId) => typeId,
    (state, typeId, inspectionId) => inspectionId,
    (estimates, typeId, inspectionId) => {
      const estimate = find(estimates, e => {
        const inspection = (e.inspection && e.inspection._id) || e.inspection;
        return e.type === typeId && inspection === inspectionId;
      });
      if (!estimate) return {};
      return estimate;
    })((state, typeId, inspectionId) => (typeId, inspectionId));



// WEBPACK FOOTER //
// ./src/modules/costEstimate/costEstimate.selectors.js